import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { updateUserProfile } from "../../redux/Actions/UserActions";
import Message from "./../LoadingError/Error";
import Loading from "./../LoadingError/Loading";
import Toast from "./../LoadingError/Toast";
import { formatNumber } from "../../service";
import { BiCopy } from "react-icons/bi";
import { FiUser, FiLink, FiBarChart2 } from "react-icons/fi";
import { FaStar, FaGift } from "react-icons/fa";
const ProfileTabs = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [dataU, setDataU] = useState({});
  const [errors, setError] = useState("");

  const toastId = React.useRef(null);

  const ToastObjects = {
    pauseOnFocusLoss: false,
    draggable: false,
    pauseOnHover: false,
    autoClose: 3000,
  };

  const dispatch = useDispatch();

  const userDetails = useSelector((state) => state.userDetails);
  const { loading, error, user } = userDetails;

  const userUpdateProfile = useSelector((state) => state.userUpdateProfile);
  const { loading: updateLoading } = userUpdateProfile;

  useEffect(() => {
    if (user) {
      setName(user.name);
      setEmail(user.email);
    }
  }, [dispatch, user]);

  const submitHandler = (e) => {
    e.preventDefault();
    // password match
    if (password !== confirmPassword) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Passwords does not match", ToastObjects);
      }
    } else {
      // update profile
      dispatch(updateUserProfile({ id: user._id, name, email, password }));
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.success("Profile Updated", ToastObjects);
      }
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      getInfoUserActive();
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const getInfoUserActive = async () => {
    // console.log(window.localStorage.getItem('userInfoActive'));
    if (!window.localStorage.getItem('userInfoActive')) {
      return
    }
    let data = JSON.parse(window.localStorage.getItem('userInfoActive'));
    // console.log(data);
    setDataU(data)
  };

  const copyTextToClipboard_ = async () => {
    navigator.clipboard.writeText(`${window.location.origin}/register?ref=${dataU?.username}`).then(function () {
      setError("Copying to clipboard was successful!")
    }, function (err) {
      setError("Could not copy text")
    });
    setTimeout(() => {
      setError("")
    }, 5000);
  }

  return (
    <>
    <Toast />
    <div className="flex flex-col gap-6">
      {/* Thông báo lỗi / loading */}
      {errors && <Message variant="info">{errors}</Message>}
      {(loading || updateLoading) && <Loading />}
  
      <div className="space-y-6">
        {/* Thông tin cơ bản */}
        <div className="bg-white shadow-md rounded-xl p-5 flex justify-between">
          <div className="space-y-3 text-gray-700">
            <p className="flex items-center gap-2">
              <FiUser className="text-blue-600" />
              <span className="font-semibold">UserName:</span> {dataU?.username}
            </p>
            <p className="flex items-center gap-2">
              <FiLink className="text-green-600" />
              <span className="font-semibold">Ref By:</span> {dataU?.ref}
            </p>
            <p className="flex items-center gap-2">
              <FaStar className="text-yellow-500" />
              <span className="font-semibold">Level:</span> A{dataU?.level}
            </p>
          </div>
          <div className="mt-4">
            <button
              onClick={copyTextToClipboard_}
              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm rounded-md shadow hover:bg-blue-700 transition"
            >
              <BiCopy size={16} /> Copy Link
            </button>
          </div>
        </div>
  
        {/* Thông tin thưởng */}
        <div className="bg-white shadow-md rounded-xl p-5">
          <h3 className="flex items-center gap-2 text-lg font-semibold text-gray-800 mb-3">
            <FaGift className="text-pink-500" /> Thông tin thưởng
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[
              { label: "Tiêu dùng cá nhân", value: dataU?.totalActive },
              { label: "GMV", value: dataU?.directSales },
              { label: "Thưởng KHTT", value: dataU?.balanceCCT },
              { label: "Thưởng KH may mắn", value: dataU?.balanceExtraB },
              {
                label: "Thưởng Đồng hành",
                value:
                  dataU?.balanceA1 +
                  dataU?.balanceA2 +
                  dataU?.balanceA3 +
                  dataU?.balanceA4 +
                  dataU?.balanceA5 +
                  dataU?.balanceA6 +
                  dataU?.balanceA7,
              },
              { label: "Thưởng kinh doanh", value: dataU?.balanceLeader },
              { label: "Thưởng hàng năm", value: 0 },
            ]?.map((item, idx) => (
              <div
                key={idx}
                className="flex justify-between items-center bg-gray-50 rounded-md px-3 py-2"
              >
                <span className="text-gray-600">{item.label}</span>
                <span className="flex items-center font-semibold text-gray-800">
                  <img src="/images/logoToken.png" alt="" className="w-5 mr-1" />
                  {formatNumber(item.value)}
                </span>
              </div>
            ))}
          </div>
        </div>
  
        {/* Tổng */}
        <div className="bg-white shadow-md rounded-xl p-5">
          <h3 className="flex items-center gap-2 text-lg font-semibold text-gray-800 mb-3">
            <FiBarChart2 className="text-indigo-600" /> Tổng
          </h3>
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Tổng nhận được</span>
            <span className="flex items-center font-bold text-green-600 text-lg">
              <img src="/images/logoToken.png" alt="" className="w-6 mr-1" />
              {formatNumber(dataU?.totalReceive?.toFixed(0))}
              <span className="mx-2 text-gray-400">/</span>
              <img src="/images/logoToken.png" alt="" className="w-6 mr-1" />
              {formatNumber(
                (dataU?.totalActive * dataU?.maxout) / 266?.toFixed(0)
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  </>
  );
};

export default ProfileTabs;
